import PropTypes from "prop-types";
import { useUserForm } from "../../hooks/useUserForm.js";
import { getUserTypeLabel } from "../../utils";
import { Icons } from "../../utils/icons.jsx";

/**
 * UserForm - Formulaire pour créer ou éditer un cavalier
 */
function UserForm({ user, onSubmit, onCancel }) {
  const {
    formData,
    errors,
    submitting,
    userTypeOptions,
    handleChange,
    handleSubmit,
    handleCancel,
  } = useUserForm(user, onSubmit, onCancel);

  return (
    <form onSubmit={handleSubmit} className="entity-form">
      {errors.submit && (
        <div className="alert alert-error">
          <Icons.Warning /> <strong>Erreur :</strong> {errors.submit}
        </div>
      )}

      <div className="form-section">
        <h3>Informations générales</h3>

        {/* Nom */}
        <div className="form-group">
          <label htmlFor="last_name">
            Nom <span className="required">*</span>
          </label>
          <input
            type="text"
            id="last_name"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            className={`form-input ${errors.last_name ? "error" : ""}`}
            placeholder="Entrez le nom de famille"
            required
            disabled={submitting}
          />
          {errors.last_name && (
            <span className="error-message">
              <Icons.Warning /> {errors.last_name}
            </span>
          )}
        </div>

        {/* Prénom */}
        <div className="form-group">
          <label htmlFor="first_name">
            Prénom <span className="required">*</span>
          </label>
          <input
            type="text"
            id="first_name"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            className={`form-input ${errors.first_name ? "error" : ""}`}
            placeholder="Entrez le prénom"
            required
            disabled={submitting}
          />
          {errors.first_name && (
            <span className="error-message">
              <Icons.Warning /> {errors.first_name}
            </span>
          )}
        </div>

        {/* Statut */}
        <div className="form-group">
          <label>
            Statut dans l'association <span className="required">*</span>
          </label>
          <div className="segmented-control">
            {userTypeOptions.map((type) => {
              const isActiveBtn = formData.user_type === type;
              return (
                <button
                  key={type}
                  type="button"
                  className={`segment-btn ${isActiveBtn ? "active" : ""}`}
                  onClick={() =>
                    handleChange({ target: { name: "user_type", value: type } })
                  }
                  disabled={submitting}
                >
                  {getUserTypeLabel(type)}
                </button>
              );
            })}
          </div>
          {errors.user_type && (
            <span className="error-message">
              <Icons.Warning /> {errors.user_type}
            </span>
          )}
        </div>

        {/* Email / Téléphone */}
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={`form-input ${errors.email ? "error" : ""}`}
              placeholder="cavalier@exemple.com"
              disabled={submitting}
            />
            {errors.email && (
              <span className="error-message">
                <Icons.Warning /> {errors.email}
              </span>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="phone">Téléphone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className={`form-input ${errors.phone ? "error" : ""}`}
              placeholder="06 12 34 56 78"
              disabled={submitting}
            />
            {errors.phone && (
              <span className="error-message">
                <Icons.Warning /> {errors.phone}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="form-section">
        <h3>Activité dans l'association</h3>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="activity_start_date">Début</label>
            <input
              type="date"
              id="activity_start_date"
              name="activity_start_date"
              value={formData.activity_start_date}
              onChange={handleChange}
              className={`form-input ${
                errors.activity_start_date ? "error" : ""
              }`}
              disabled={submitting}
            />
            {errors.activity_start_date && (
              <span className="error-message">
                <Icons.Warning /> {errors.activity_start_date}
              </span>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="activity_end_date">Fin</label>
            <input
              type="date"
              id="activity_end_date"
              name="activity_end_date"
              value={formData.activity_end_date}
              onChange={handleChange}
              className={`form-input ${
                errors.activity_end_date ? "error" : ""
              }`}
              disabled={submitting}
            />
            <small className="form-help">Laissez vide si toujours actif</small>
            {errors.activity_end_date && (
              <span className="error-message">
                <Icons.Warning /> {errors.activity_end_date}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancel}
          disabled={submitting}
        >
          <Icons.Cancel /> Annuler
        </button>
        <button type="submit" className="btn btn-primary" disabled={submitting}>
          {submitting ? (
            <>
              <Icons.Loading className="spin" /> Enregistrement...
            </>
          ) : (
            <>
              <Icons.Save /> {user ? "Mettre à jour" : "Créer"}
            </>
          )}
        </button>
      </div>
    </form>
  );
}

UserForm.propTypes = {
  user: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default UserForm;
